// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"a4a98a5a","277":"e7924e9c","327":"5a5d0e9a","329":"36903244","501":"106e3414","539":"7150139d","937":"beab8998"}[chunkId] + ".js";
};